/**
 * Per-sheet scale override (pilot: localStorage until drawingGeometryApi persists).
 */

import { parseScaleRatio } from './drawingMeasurements.js';

export function scaleOverrideKey(projectId, requirementId, sheetId) {
  return `codiii-review-scale:${projectId || ''}:${requirementId || ''}:${sheetId || ''}`;
}

export function loadScaleOverride(key) {
  if (!key || typeof localStorage === 'undefined') return null;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.ratio?.denominator) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveScaleOverride(key, ratio, { label } = {}) {
  if (!key || !ratio || typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(key, JSON.stringify({
      ratio,
      label: label || ratio.label || `${ratio.numerator}:${ratio.denominator}`,
      source: 'user_override',
      updatedAt: new Date().toISOString(),
    }));
  } catch {
    // quota
  }
}

export function clearScaleOverride(key) {
  if (!key || typeof localStorage === 'undefined') return;
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
}

/** Parse user calibration text (1:48, 1/8" = 1'-0", etc.). */
export function parseCalibrationInput(text) {
  return parseScaleRatio(String(text || '').trim());
}

/**
 * Merge auto-detected sheet scale with user override.
 * @returns {object | null}
 */
export function resolveEffectiveSheetScale(detected, override) {
  if (override?.ratio) {
    return {
      ...detected,
      ...override,
      ratio: override.ratio,
      source: 'user_override',
      label: override.label || override.ratio.label,
    };
  }
  return detected;
}
